module.exports = __webpack_public_path__ + "static/media/icon-stack.cdfb0161.svg";